import { useParams } from 'react-router-dom';

import MCTMonitoring from './MCTMonitoring/MCTMonitoring';
import ReportsHeader from './ReportsHeader';
import SBSMonitoring from './SBSMonitoring/SBSMonitoring';
import SRSTMonitoring from './SRSTMonitoring/SRSTMonitoring';
import SMSTMonitoring from './SMSTMonitoring/SMSTMonitoring';
import './allMonitoring.scss';

import { useAppSelector } from 'slices';
import { ReportTableType } from 'components/ReportsTables/ReportTableType';

interface TabPanelProps {
  children?: React.ReactNode;
  tableName: string;
  currentTable: string;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, currentTable, tableName } = props;

  return (
    <div hidden={currentTable !== tableName} id={`Table-${tableName}`}>
      {currentTable === tableName && <>{children}</>}
    </div>
  );
}

const Reports: React.FC = () => {
  const { slug } = useParams();
  const currentTab = useAppSelector(state => state.Reports.currentReportTable);

  return (
    <div>
      <ReportsHeader />
      <CustomTabPanel currentTable={currentTab} tableName={ReportTableType.MCTMonitoring}>
        <MCTMonitoring slug={slug || ''} />
      </CustomTabPanel>
      <CustomTabPanel currentTable={currentTab} tableName={ReportTableType.SRBMMonitoring}>
        <SBSMonitoring slug={slug || ''} />
      </CustomTabPanel>
      <CustomTabPanel currentTable={currentTab} tableName={ReportTableType.SRSTMonitoring}>
        <SRSTMonitoring slug={slug || ''} />
      </CustomTabPanel>
      <CustomTabPanel currentTable={currentTab} tableName={ReportTableType.SMSTMonitoring}>
        <SMSTMonitoring slug={slug || ''} />
      </CustomTabPanel>
    </div>
  );
};
export default Reports;
